import { FriendsManager } from "@/components/meal-plan/friends-manager";

export function FriendsPage() {
  return (
    <div className="w-full mx-auto max-w-3xl px-4 py-6 flex-1 overflow-y-auto">
      <FriendsManager />
    </div>
  );
}
